// Common route options used across the application
export const ROUTE_OPTIONS = [
    { label: 'All Routes', value: null },
    { label: 'COPA-Este', value: 'COPA-Este' },
    { label: 'Chorrera-Clayton', value: 'Chorrera-Clayton' },
    { label: 'CDE-Sta. Maria', value: 'CDE-Sta. Maria' },
    { label: 'Obarrio Via España', value: 'Obarrio Via España' },
    { label: 'SFC Paitilla', value: 'SFC Paitilla' },
    { label: 'Puertos', value: 'Puertos' },
    { label: 'Tocumen', value: 'Tocumen' },
    { label: 'Centro-Oeste', value: 'Centro-Oeste' },
    { label: 'Centro-Pacifico CAFE', value: 'Centro-Pacifico CAFE' },
    { label: 'Colon - Norte-Este', value: 'Colon - Norte-Este' },
];

// Default route options (just "All Routes")
export const DEFAULT_ROUTE_OPTIONS = [{ label: 'All Routes', value: null }];
